export default function CTASection() {
  return (
    <section className="relative py-20 md:py-32 px-4 md:px-6 lg:px-10 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Australian%20suburban%20neighborhood%20at%20sunset%20with%20solar%20panels%20visible%20on%20multiple%20rooftops%20some%20homes%20with%20warm%20lights%20on%20gently%20rolling%20hills%20in%20background%20scattered%20native%20eucalyptus%20trees%20soft%20golden%20hour%20light%20warm%20and%20inviting%20atmosphere%20sustainable%20community%20vibe&width=1800&height=1000&seq=cta-bg-energy&orientation=landscape"
          alt="Australian sustainable community with renewable energy at sunset"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/25 via-foreground-950/15 to-foreground-950/35" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-white mb-5">
          Ready To Join The Future Of
          <br />
          <span className="relative" style={{ color: '#2FA84F' }}>
            Renewable Energy
          </span>
          ?
        </h2>

        <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto mb-10">
          Whether you are a homeowner, business, installer, manufacturer or finance provider — AK Energy is Australia&rsquo;s trusted renewable energy marketplace, connecting you with the right renewable energy opportunities and verified providers to accelerate the transition towards cleaner energy solutions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-400 transition-all duration-200 cursor-pointer"
          >
            Get Started
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="#partners"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl border-2 border-white/30 text-white hover:bg-white/10 hover:border-white/50 transition-all duration-200 cursor-pointer"
          >
            Become a Partner
            <i className="ri-group-line text-lg"></i>
          </a>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-8">
          {[
            { value: '2,000+', label: 'Active Users' },
            { value: '150+', label: 'Verified Partners' },
            { value: '98%', label: 'Satisfaction Rate' },
            { value: '5', label: 'Energy Categories' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-extrabold text-white font-heading">{stat.value}</p>
              <p className="text-xs text-white/60 font-medium mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}